import { useState } from 'react';
import { useLang } from '../../../i18n/LanguageContext';
import ConsultationModal from './ConsultationModal';

export default function Hero() {
  const { t } = useLang();
  const [isConsultationOpen, setIsConsultationOpen] = useState(false);

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-20 pb-32 px-4 sm:px-8">
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
      
      <div className="relative z-10 w-full max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-3 space-y-6 sm:space-y-8">
            <div className="inline-flex items-center space-x-2 px-3 sm:px-4 py-2 bg-[#d4af37]/20 rounded-full border border-[#d4af37]/30">
              <i className="ri-sparkling-line text-[#d4af37] text-sm sm:text-base"></i>
              <span className="text-[#d4af37] text-xs sm:text-sm">{t('Ancient Wisdom · Modern Practice', '古老智慧 · 现代修行')}</span>
            </div>

            <div className="space-y-3 sm:space-y-4">
              <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-serif text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#c8b6ff] leading-tight">
                {t('Explore the Infinite', '探索无限')}
              </h1>
              <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-serif text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#c8b6ff] leading-tight">
                {t('Mysteries of the Occult', '神秘学的奥秘')}
              </h1>
              <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-serif text-transparent bg-clip-text bg-gradient-to-r from-[#d4af37] to-[#c8b6ff] leading-tight">
                {t('Begin Your Magical Journey', '开启你的魔法旅程')}
              </h1>
            </div>

            <p className="text-base sm:text-lg md:text-xl text-[#c8b6ff] leading-relaxed max-w-2xl">
              {t(
                'Professional Tarot, Astrology, Healing & Magic Courses',
                '专业塔罗、占星与疗愈及魔法课程'
              )}
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 sm:gap-4 pt-4">
              <button
                onClick={() => document.getElementById('courses')?.scrollIntoView({ behavior: 'smooth' })}
                className="px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-[#2d1b4e] to-[#4a2d6e] text-[#d4af37] rounded-full hover:shadow-lg hover:shadow-[#d4af37]/30 transition-all duration-300 cursor-pointer whitespace-nowrap flex items-center justify-center space-x-2 font-medium text-sm sm:text-base">
                <i className="ri-magic-line"></i>
                <span>{t('Start Learning', '开始学习')}</span>
              </button>

            </div>

            <div className="flex flex-wrap items-center gap-6 sm:gap-8 lg:gap-12 pt-6 sm:pt-8">
              <div className="flex items-center space-x-2 sm:space-x-3">
                <i className="ri-group-line text-2xl sm:text-3xl text-[#d4af37]"></i>
                <div>
                  <div className="text-xl sm:text-2xl font-bold text-white">{t('Global', '全球')}</div>
                  <div className="text-xs sm:text-sm text-[#c8b6ff]">{t('Students', '学员')}</div>
                </div>
              </div>
              <div className="flex items-center space-x-2 sm:space-x-3">
                <i className="ri-star-line text-2xl sm:text-3xl text-[#d4af37]"></i>
                <div>
                  <div className="text-xl sm:text-2xl font-bold text-white">{t('Multi-dim', '多维')}</div>
                  <div className="text-xs sm:text-sm text-[#c8b6ff]">{t('Courses', '课程')}</div>
                </div>
              </div>
              <div className="flex items-center space-x-2 sm:space-x-3">
                <i className="ri-award-line text-2xl sm:text-3xl text-[#d4af37]"></i>
                <div>
                  <div className="text-xl sm:text-2xl font-bold text-white">{t('Certificate', '证书')}</div>
                  <div className="text-xs sm:text-sm text-[#c8b6ff]">{t('Certification', '认证')}</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-2 mt-8 lg:mt-0">
            <div className="relative rounded-3xl overflow-hidden shadow-2xl border-2 border-[#d4af37]/30 max-w-md mx-auto lg:max-w-none">
              <img
                src="https://public.readdy.ai/ai/img_res/1f197879af6f10db13273bf0b7c32d79.jpg"
                alt="Mystic Witch"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#2d1b4e]/60 to-transparent"></div>
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full flex items-center justify-center pointer-events-none">
                <div className="relative w-48 h-48 sm:w-64 sm:h-64">
                  <div className="absolute inset-0 animate-spin-slow">
                    <i className="ri-sparkling-2-line text-4xl sm:text-6xl text-[#d4af37]/30 absolute top-0 left-1/2 transform -translate-x-1/2"></i>
                    <i className="ri-moon-line text-3xl sm:text-5xl text-[#d4af37]/30 absolute right-0 top-1/2 transform -translate-y-1/2"></i>
                    <i className="ri-sun-line text-3xl sm:text-5xl text-[#d4af37]/30 absolute bottom-0 left-1/2 transform -translate-x-1/2"></i>
                    <i className="ri-star-line text-2xl sm:text-4xl text-[#d4af37]/30 absolute left-0 top-1/2 transform -translate-y-1/2"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConsultationModal
        isOpen={isConsultationOpen}
        onClose={() => setIsConsultationOpen(false)}
      />
    </section>
  );
}